import { histState, histMutations, histActions } from "./historico.js";
import { dashState, dashMutations, dashActions } from "./dashboard.js";
import { createState, createMutations, createActions, createGetters } from "./create.js";
import { recursosState, recursosMutations, recursosActions, recursosGetters } from "./recursos.js";
export default {
  namespaced: true,
  state:     { ...dashState, ...createState, ...histState, ...recursosState },
  mutations: { ...dashMutations, ...createMutations, ...histMutations, ...recursosMutations },
  actions:   { ...dashActions, ...createActions, ...histActions , ...recursosActions },
  getters:   { ...createGetters, ...recursosGetters },
};
